/**
 * Where a push notification leads when it is tapped, read from the `data`
 * the API sends with it. Kept free of navigation so it can be tested alone.
 */
export type PushData = Record<string, string | undefined>

export type PushTarget =
  | { kind: 'conversation'; conversationId: string; isGroup: boolean }
  // A follow-up about someone with an account: open (or start) the conversation.
  | { kind: 'writeTo'; contactId: string }
  | { kind: 'profile'; profileId: string }
  | { kind: 'event'; eventId: string }
  | { kind: 'birthdays' }
  | { kind: 'notifications' }

export const pushTarget = (data: PushData | undefined | null): PushTarget => {
  const d = data ?? {}
  switch (d.type) {
    case 'NEW_MESSAGE':
      if (d.conversationId) {
        return { kind: 'conversation', conversationId: d.conversationId, isGroup: d.isGroup === 'true' }
      }
      break
    case 'KEEP_CONTACT_REMINDER':
      if (d.contactId) {
        return d.isGhost === 'true'
          ? { kind: 'profile', profileId: d.contactId }
          : { kind: 'writeTo', contactId: d.contactId }
      }
      break
    case 'BIRTHDAY_UPCOMING':
      if (d.contactId) return { kind: 'profile', profileId: d.contactId }
      // Tomorrow's birthdays: the list, where « Programmer mes vœux » is.
      return d.url === '/notifications' ? { kind: 'notifications' } : { kind: 'birthdays' }
    case 'CALENDAR_EVENT_UPCOMING':
      if (d.calendarEventId) return { kind: 'event', eventId: d.calendarEventId }
      break
    case 'CONTACT_REQUEST_ANSWERED':
      if (d.recipientId) return { kind: 'profile', profileId: d.recipientId }
      break
  }
  return { kind: 'notifications' }
}
